import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { nextReferral } from './referral';

/**
 * The partner referral code of this visit (src/web/lib/referral.ts), held in
 * memory by the layout and read by whatever renders a sign-up link.
 *
 * It is picked up in an effect, so the server HTML and the first client render
 * (which cannot know the URL's query) agree; it is never written to a cookie
 * or storage, and a reload of a page without `?ref=` forgets it.
 */
export const ReferralContext = createContext<string | null>(null);

/** Remembers the latest valid `?ref=` seen during this visit (used once, by the layout). */
export function useRememberedReferral(): string | null {
  const { search } = useLocation();
  const [code, setCode] = useState<string | null>(null);
  useEffect(() => setCode((current) => nextReferral(current, search)), [search]);
  return code;
}

export function useReferral(): string | null {
  return useContext(ReferralContext);
}
